module.exports = "/static/assets/a1878b1b94f69b677ce8578b187a7416.png";